import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import classNames from 'classnames';
import classes from './InstructorA.module.scss';

const { string, number, shape } = PropTypes;

const InstructorA = (props) => {
  const {
    heading,
    subHeading,
    content,
    additionalContent,
    image,
  } = props;

  const { url, altText, height, width } = image || {};
  const description = `${content}${additionalContent ? `\n\n${additionalContent}` : ''}`;
  const [expanded, setExpanded] = useState(false);
  const instructorImage = url &&
    <img
      className={classes.image}
      src={url}
      alt={altText}
      width={width}
      height={height}
      loading='lazy'
      aria-hidden
    />;

  return (
    <div className={classNames(classes.wrapper, { [classes.expanded]: expanded })}>
      {url && (
        <span className={classes.imageWrapper}>
          {instructorImage}
        </span>
      )}
      <div className={classes.contentWrapper}>
        <div className={classes.headersWrapper}>
          {url && (
            <span className={classes.mobileImageWrapper}>
              {instructorImage}
            </span>
          )}
          <div className={classes.buttonAndHeadersWrapper}>
            <div className={classes.mobileButtonWrapper}>
              <button
                aria-label={expanded ? 'Show Less' : 'Show More'}
                className={classes.button}
                onClick={() => setExpanded(!expanded)}
                type='button'
              >
                {expanded ? (
                  <FontIcon icon='far fa-minus' />
                ) : (
                  <FontIcon icon='far fa-plus' />
                )}
              </button>
            </div>
            <h2
              className={classes.header}
              dangerouslySetInnerHTML={{ __html: heading }}
            />
            <h3
              className={classes.subheader}
              dangerouslySetInnerHTML={{ __html: subHeading }}
            />
          </div>
        </div>
        <div
          className={classes.description}
          dangerouslySetInnerHTML={{
            __html: expanded ? description : content,
          }}
        />
        {typeof window === 'undefined' &&
          <div
            dangerouslySetInnerHTML={{
              __html: additionalContent,
            }}
          />}
        {additionalContent &&
          <div className={classes.buttonWrapper}>
            <button
              aria-label={expanded ? 'Read Less' : 'Read More'}
              className={classes.button}
              onClick={() => setExpanded(!expanded)}
              type='button'
            >
              {expanded ? (
                <span>Read less</span>
              ) : (
                <span>Read more</span>
              )}
            </button>
          </div>}
      </div>
    </div>
  );
};

InstructorA.propTypes = {
  /**
   * Text displays at the top of component
  */
  heading: string,
  /**
   * Text displays under heading
  */
  subHeading: string,
  /**
   * Text displays under subheading
  */
  content: string,
  /**
   * Text displays under content, if `Read more` button is clicked
  */
  additionalContent: string,
  /**
   * Image Object
  */
  image: shape({
    url: string,
    altText: string,
    height: number,
    width: number,
  }),
};

export default InstructorA;
